import MicroModal from 'micromodal';

import { useFormSend } from '../form/form';
import { init as initMaps } from '../utils/maps';
import { trackFormSubmit } from '../tracking';

const init = () => {
  const locationFinderForms = [
    ...document.querySelectorAll('[data-plugin="location-finder"]'),
  ];
  const fullMap = document.querySelector('[data-plugin="full-map"]');

  if (locationFinderForms?.length) {
    locationFinderForms.forEach((form) => {
      useLocationFinderForm({ form });
    });
  }

  if (fullMap) {
    initMaps({ fullMap });
  }
};

const useLocationFinderForm = ({ form }) => {
  const input = form.elements.location_finder;
  if (!input) return;

  const locationResults = document.querySelector('[data-target="location-results"]');
  const selectedAddressBlock = document.querySelector(
    '[data-target="selected-address-block"]'
  );
  const selectedAddress = document.querySelector('[data-target="selected-address"]');
  const nearbyUserButton = form.querySelector('[data-plugin="locations-nearby"]');
  const modalNearbyUserButton = document.querySelector(
    '#modal-location-finder [data-plugin="locations-nearby"]'
  );

  const showSelectedAddressBlock = () => {
    selectedAddressBlock.classList.add('block');
    selectedAddressBlock.classList.remove('hidden');
  };
  const hideSelectedAddressBlock = () => {
    selectedAddressBlock.classList.remove('block');
    selectedAddressBlock.classList.add('hidden');
  };
  const setSelectedAddress = (address = '') => {
    selectedAddress.innerHTML = address;
  };

  const setLocationResults = (data) => {
    const html =
      data?.locationHtml ||
      `<h3 class="Heading-2">No locations found.</h3><p class="text-lg">Try a different address.</p>`;

    locationResults.innerHTML = html;

    if (data.coords?.formatted) {
      setSelectedAddress(data.coords.formatted);
      showSelectedAddressBlock();
    }
  };

  const { send } = useFormSend({
    form,
    onBefore: () => {
      setLocationResults({
        locationHtml: '<h3 class="Heading-2">Searching...</h3>',
      });
      hideSelectedAddressBlock();
      showLocationFinderModal();
    },
    onSuccess: ({ data }) => {
      setLocationResults(data);
    },
    onFail: ({ message }) => {
      setLocationResults({
        locationHtml: `<p class="text-lg dt:text-xl font-bold">${message ||
          'There was an issue finding locations, refresh the page and try again.'
          }</p>`,
      });
    },
  });

  const modalInput = document.querySelector(
    '#modal-location-finder [name="location_finder"]'
  );
  const modalNearbyUserInput = document.querySelector(
    '#modal-location-finder [name="is_nearby_user"]'
  );
  const nearbyUserInput = form.elements.is_nearby_user;

  form.addEventListener('submit', (event) => {
    event.preventDefault();
    nearbyUserInput.value = '';
    if (!(modalNearbyUserInput.value === 'true' && input.value === '')) {
      modalNearbyUserInput.value = '';
    }
    if (modalInput.value !== input.value) {
      modalInput.value = input.value;
    }
    modalNearbyUserButton.classList.remove('hidden');
    modalNearbyUserButton.classList.add('block');
    trackFormSubmit(form, { offer: input.value });
    send().catch((e) => { /* console.error('Location finder form', e) */ });
  });

  nearbyUserButton?.addEventListener('click', () => {
    modalNearbyUserInput.value = 'true';
    nearbyUserInput.value = 'true';
    modalInput.value = '';
    input.value = '';
    modalNearbyUserButton.classList.add('hidden');
    modalNearbyUserButton.classList.remove('block');
    trackFormSubmit(form, { offer: nearbyUserButton.innerText });
    send().catch((e) => { /* console.log('Location finder nearby user', e) */ });
  });

  const procedureControls = [...form.querySelectorAll('[name="procedure_control"]')];
  if (procedureControls.length) {
    procedureControls.forEach((control) => {
      control.addEventListener('change', () => {
        trackFormSubmit(form, { offer: control.value });
        send().catch((e) => { /* console.log('Procedure controls', e) */ });
      });
    });
  }
};

const showLocationFinderModal = (data) => {
  MicroModal.show('modal-location-finder', {
    openTrigger: 'data-modal-open',
    closeTrigger: 'data-modal-close',
    disableScroll: true,
    disableFocus: true,
  });
};

export default init;
